export const getCurrentPath = (routes: string[] | undefined) => {
  if (typeof window !== "undefined") {
    if (routes && window.next) {
      const router = window?.next?.router;
      return routes.includes(`${router?.basePath}${router?.state?.route}`);
    }
  }
  // 服务器端和客户端未匹配时都返回 false，保持一致
  return false;
};
